import { configureStore } from '@reduxjs/toolkit'
import projectSlice from './project/projects'
import routerSlice from './router/router'
export const store = configureStore({
  reducer: {
    projectSlice,
    routerSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
})